import React from 'react';
import TextReveal from '../animations/TextReveal';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  dark?: boolean;
  className?: string;
  center?: boolean;
}

export default function SectionTitle({
  title,
  subtitle,
  dark = false,
  className = '',
  center = true,
}: SectionTitleProps) {
  return (
    <div className={`${center ? 'text-center' : ''} mb-3 sm:mb-4 ${className}`}>
      <TextReveal
        as="h2"
        className={`text-2xl sm:text-3xl lg:text-4xl font-extrabold leading-tight ${
          dark ? 'gradient-text' : 'text-text-dark'
        }`}
      >
        {title}
      </TextReveal>
      {subtitle && (
        <p
          className={`mt-1 sm:mt-2 text-base sm:text-lg max-w-2xl ${center ? 'mx-auto' : ''} ${
            dark ? 'text-gray-400' : 'text-text-gray'
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
